import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiDtgDangerDriveService
    ,FvmsApiAuthService
    ,FvmsExcelService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
} from "src/app/shared/vo";
import {
    DtgManageCarSearchComponent
} from "src/app/dtg/manage/car";
import {
    DtgAnalyticsDriveDangerStopHighRpmDetailComponent
} from "../detail/dtg.analytics.drive.danger.stopHighRpm.detail.component";

@Component({
    selector: "dtg-analytics-drive-danger-stop-high-rpm-list"
    ,templateUrl: './dtg.analytics.drive.danger.stopHighRpm.list.component.html'
    ,providers: []
})
export class DtgAnalyticsDriveDangerStopHighRpmListComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    dateTimeInfo:any;
    currentUserInfo:any;
    pagingInfo:PagingInfo = new PagingInfo();
    dayDiff:number=0;
    listTeam:any[];
    searchValue:string;
    @Input() listType:DtgListType = DtgListType.list;
    @Output() teamInfo = new EventEmitter();
    DtgActionType = DtgActionType;
    DtgListType = DtgListType;
    userGroupId:number;
    dtgTeamId:string = "";
    dtgUnitId:string;
    dtgCarNo:string;
    dtgGpsAddr:string;
    dtgActionType = DtgActionType;
    
    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiDtgDangerDriveService:FvmsApiDtgDangerDriveService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsExcelService:FvmsExcelService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        this.pagingInfo.pageSize = 15;
        this.dateTimeInfo = this.fvmsCommonService.getDateInfo();

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
                this.pagingInfo.curPage = 1;
                this.reloadListItem();
            });

        this.fvmsCommonService.subscribeDateInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(dateTimeInfo => {
                this.dateTimeInfo = dateTimeInfo;
                // this.dateInfo = dateInfo;
                // let dateFrom = new Date(this.dateInfo.fromDate.year,this.dateInfo.fromDate.month,this.dateInfo.fromDate.day);
                // let dateTo = new Date(this.dateInfo.toDate.year,this.dateInfo.toDate.month,this.dateInfo.toDate.day);
                // let dateDiff = this.filterDateDiff.transform(dateFrom,dateTo,"day");
                // this.dayDiff = dateDiff + 1;
                this.reloadListItem();
            });
     }

    ngOnInit() {
        this.reloadListItem();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    reloadListItem(){
        if(!this.dtgUnitId){
            return;
        }
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            ,dtgDriveRuleType : 102
            ,searchValue : this.searchValue
            ,searchDateFrom: this.fvmsCommonService.getDateFromIsoReserve()
            ,searchDateTo: this.fvmsCommonService.getDateToIsoReserve()
            ,dtgUnitId: this.dtgUnitId
            ,dtgGpsAddr: this.dtgGpsAddr
        };
        this.fvmsApiDtgDangerDriveService.getListDangerDriveHis(searchInfo,this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listTeam = apiResponse.resultValue;
                    this.pagingInfo = apiResponse.pagingInfo;
                }
            });
    }

    callbackClickPageNumber(pageNo: number) {
        this.pagingInfo.curPage=pageNo;
        this.reloadListItem();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.callbackClickPageNumber(1);
    }

    clickSelectTeam(teamInfo:any){
        this.teamInfo.emit(teamInfo);
    }

    //검색어 입력란에 엔터키 누르면 실행
    keyupEnterSearchValue(e){
        this.reloadListItem();
    }

    clickSearch(){
        this.reloadListItem();
    }

    clickOpenModalGeofenceCarList(dtgActionType:DtgActionType){
        let modalRef = this.modalService.open(
            DtgManageCarSearchComponent
            ,{
                centered:true
                ,size: "xl"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );

        modalRef.result.then((resultModal) => {
            if(resultModal.result === "ok"){
                this.dtgUnitId = resultModal.carInfo.dtgUnitId;
                this.dtgCarNo = resultModal.carInfo.dtgCarNo;
                this.reloadListItem();
            }
        });
    }

    clickOpenModalStopHighRpmDetail(dtgActionType:DtgActionType,item){
        let modalRef = this.modalService.open(
            DtgAnalyticsDriveDangerStopHighRpmDetailComponent
            ,{
                centered:true
                ,size: "xl"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );

        modalRef.componentInstance.dtgListType = DtgListType.modal;
        modalRef.componentInstance.dtgActionType = dtgActionType;
        modalRef.componentInstance.dtgUnitId = item?.dtgUnitId;
        modalRef.componentInstance.dtgDriveRuleType = item?.dtgDriveRuleType;
        modalRef.componentInstance.fvmsTripCnt = item?.fvmsTripCnt;
        modalRef.componentInstance.dtgRegDtFrom = item?.dtgRegDtFrom;

        modalRef.result.then((resultModal) => {});
    }
}